import { render, staticRenderFns } from "./BookingThreadList.vue?vue&type=template&id=41c9c508"
import script from "./BookingThreadList.vue?vue&type=script&lang=js"
export * from "./BookingThreadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports